"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _subscribe = _interopRequireDefault(require("../subscribe"));

var _useCloneModel3 = _interopRequireDefault(require("./internalHooks/useCloneModel"));

var _useService = _interopRequireDefault(require("./internalHooks/useService"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useModel = function useModel(model, deps, options) {
  var finalOptions = _objectSpread(_objectSpread({}, _constants.defaultServiceOptions), options);

  var optionsRef = (0, _react.useRef)(finalOptions);
  optionsRef.current = finalOptions;

  var _useState = (0, _react.useState)(function () {
    return [model];
  }),
      _useState2 = _slicedToArray(_useState, 1),
      modelDeps = _useState2[0];

  var _useCloneModel = (0, _useCloneModel3.default)(model, [modelDeps], finalOptions),
      _useCloneModel2 = _slicedToArray(_useCloneModel, 2),
      clonedModel = _useCloneModel2[0],
      status = _useCloneModel2[1];

  (0, _useService.default)(clonedModel, deps, finalOptions);

  var _useState3 = (0, _react.useState)(function () {
    return {
      data: model()
    };
  }),
      _useState4 = _slicedToArray(_useState3, 1),
      cachedState = _useState4[0];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = _slicedToArray(_useState5, 2),
      updateState = _useState6[1];

  var onChangeCallback = (0, _react.useCallback)(function (state) {
    if (optionsRef.current.onChange) {
      var data = cachedState.data;
      cachedState.data = state;
      optionsRef.current.onChange(state, data);
    }
  }, []);

  var _useState7 = (0, _react.useState)(function () {
    return model.onChange(onChangeCallback);
  }),
      _useState8 = _slicedToArray(_useState7, 1),
      offChange = _useState8[0];

  var _useState9 = (0, _react.useState)(function () {
    return (0, _subscribe.default)(modelDeps, function (_modelData) {
      updateState(function (count) {
        return count + 1;
      });
    }, false);
  }),
      _useState10 = _slicedToArray(_useState9, 1),
      unsub = _useState10[0];

  (0, _react.useEffect)(function () {
    return function () {
      unsub();
      offChange();
    };
  }, []);
  return [model(), clonedModel, status];
};

var _default = useModel;
exports.default = _default;